import { useFormat } from 'vivat';

// eslint-disable-next-line
const toCurrency = (string: string | number) => parseFloat(string as string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    distanceType: {
      name: 'ระยะทาง',
      width: '7rem',
    },
    deliveryDate: {
      name: 'วันที่ออกรถ',
      width: '7rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    uniqueId: {
      name: 'เลขที่​ใบจัดรถ',
      width: '1fr',
    },
    // payment: {
    //   name: 'รหัสการจ่าย',
    //   width: '1.5fr',
    // },
    distanceTravelled: {
      name: 'ระยะทาง (กม.)',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => toCurrency(val),
    },
    // senderAddress: {
    //   name: 'สถานที่จัดส่ง',
    //   width: '6rem',
    // },
    totalWeight: {
      name: 'น้ำหนัก (กก.)',
      width: '6rem',
      class: 'text-right',
      filter: (val: number) => toCurrency(val),
    },
    fee: {
      name: 'ค่าปรับ',
      width: '5rem',
      class: 'text-right',
    },
    fine: {
      name: 'ค่าเที่ยว',
      width: '5rem',
      class: 'text-right',
    },
    driverAllowance: {
      name: 'เบี้ยเลี้ยง',
      width: '5rem',
      class: 'text-right',
    },
    deliveryManCount: {
      name: 'พนักงานยกของ',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => `${val} คน`,
    },
    createdAt: {
      name: 'จัดรถเมื่อ',
      width: '12rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    createdBy: {
      name: 'ผู้จัดรถ',
      width: '8rem',
    },
  },
  sortable: [
    'createdTime',
    'uniqueId',
    'deliveryManCount',
    'deliveryDate',
    // 'distance',
    // 'place',
    // 'weight',
    // 'price',
    // 'bonus',
    // 'companion',
    // 'organizer',
  ],
};
